<osp-sidebar
  [(sidenavItems)]="$sidenavItems"
  [logo]="$logo()"
  [fixedToggleIcon]="IconKey.SidebarExpand | icon"
  [unfixedToggleIcon]="IconKey.SidebarCollapse | icon"
  [fixedToggleTooltip]="'modules.navigation.sidebar.pinHint.pin' | translate"
  [unfixedToggleTooltip]="'modules.navigation.sidebar.pinHint.unpin' | translate"
  (state)="onStateChange($event)"
>
  @if (!equipmentShortcutService.$isEmpty()) {
    <ng-template [ospTemplate]="EQUIPMENT_SUB_CONTAINER_NAME">
      <osp-shortcut-list
        [shortcutProvider]="equipmentShortcutService"
        (shortcutSelect)="equipmentShortcutService.navigate($event)"
      />
    </ng-template>
  }
</osp-sidebar>
